import { createTheme } from "@mui/material/styles";
import "@fontsource/outfit"; // Import Outfit font

const theme = createTheme({
  typography: {
    fontFamily: '"Outfit", sans-serif', // Use Outfit font here
  },
  palette: {
    primary: {
      main: "#2D4A3D", // Updated primary green from your UI
    },
    secondary: {
      main: "#6B8F71", // Soft green for secondary elements
    },
    accent: {
      main: "#F8B400", // Golden yellow for highlights
    },
  },
});

export default theme;
